/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadAdmission,
  WorkloadAdmission$inboundSchema,
} from "./workloadadmission.js";
import {
  WorkloadIssuer,
  WorkloadIssuer$inboundSchema,
} from "./workloadissuer.js";

/**
 * The whole trust policy visible to the caller. Every write returns this, so a client replaces its view rather than merging into it and cannot show a stale list after a mutation.
 */
export type WorkloadIdentityPolicy = {
  /**
   * Admitted subjects.
   */
  admissions: Array<WorkloadAdmission>;
  /**
   * Trusted issuers, organization tier first.
   */
  issuers: Array<WorkloadIssuer>;
};

/** @internal */
export const WorkloadIdentityPolicy$inboundSchema: z.ZodMiniType<
  WorkloadIdentityPolicy,
  unknown
> = z.object({
  admissions: z.array(WorkloadAdmission$inboundSchema),
  issuers: z.array(WorkloadIssuer$inboundSchema),
});

export function workloadIdentityPolicyFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadIdentityPolicy, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadIdentityPolicy$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadIdentityPolicy' from JSON`,
  );
}
